export const LEAD_SCREEN = 'LEAD_SCREEN';
export const LEAD_PROFILE = 'LEAD_PROFILE';
export const LEAD_PAGE = 'LEAD_PAGE';
export const UPDATE_LEAD_DATA = 'UPDATE_LEAD_DATA';
export const UPDATE_NAV_STATE = 'UPDATE_NAV_STATE';
export const UPDATE_ABOUT_YOU_STATE = 'UPDATE_ABOUT_YOU_STATE';
// retiremnt
export const LEAD_UPDATE_GOALTYPE = 'LEAD_UPDATE_GOALTYPE';
export const LEAD_RETIREMENT_AGE = 'LEAD_RETIREMENT_AGE';
export const LEAD_MONTHLY_INCOME = 'LEAD_MONTHLY_INCOME';
export const LEAD_RETIREMENT_INCOME = 'LEAD_RETIREMENT_INCOME';
export const LEAD_ANNUAL_SAVING = 'LEAD_ANNUAL_SAVING';
export const LEAD_SKIP_GOAL_INFO = 'LEAD_SKIP_GOAL_INFO';
export const LEAD_INVESTER_TARGET = 'LEAD_INVESTER_TARGET';
export const LEAD_NAV_STATE = 'LEAD_NAV_STATE';
